import { render } from "./AddressProgramOrder.vue?vue&type=template&id=9b4b19b8"
import script from "./AddressProgramOrder.vue?vue&type=script&lang=js"
export * from "./AddressProgramOrder.vue?vue&type=script&lang=js"

import "./AddressProgramOrder.vue?vue&type=style&index=0&id=9b4b19b8&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__